export const GET_SAVING_KEY = "getSaving"
export const EXIT_FEE_KEY = "exitFee"
export const RENEWAL_WINDOW_CONFIGURATION = "RENEWAL_WINDOW"
